import { createServerFn } from '@tanstack/react-start';
import api from '../utils/api';
import { filterActiveProperty } from '../utils/photoUtils';

export const getPropertyDetail = createServerFn()
    .validator((data) => data)
    .handler(async ({ data }) => {
        const { slug } = data;
        const response = await api('get', `property/${slug}`);
        return filterActiveProperty(response.data) || [];
    });

